import React, { useEffect, useRef } from "react";
import { func } from "prop-types";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import { DateRangeField } from "pages/_components/fields/DateRangeField";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import { getLimitDate } from "util/date";
import * as i18n from "util/i18n";
import AmountField from "pages/_components/fields/formik/AmountField";

const FORM_ID = "discounts";

const FilterForm = ({ setOpenSidebar, setFilters }) => {
    const formRef = useRef(null);
    const { echeqFilters } = useSelector((state) => state.discounts);

    const initialValues = {
        receiver: "",
        amountFrom: { amount: "" },
        amountTo: { amount: "" },
        dateRangePayed: [null, null],
    };

    useEffect(() => {
        if (!formRef.current) {
            return;
        }
        const nextValues = {
            receiver: echeqFilters?.receiver ?? "",
            amountFrom: { amount: echeqFilters?.amountFrom ?? "" },
            amountTo: { amount: echeqFilters?.amountTo ?? "" },
            dateRangePayed: [echeqFilters?.payedFrom ?? null, echeqFilters?.payedTo ?? null],
        };
        formRef.current.resetForm(nextValues);
    }, [echeqFilters]);

    const handleSubmit = (values) => {
        if (
            (!!values.dateRangePayed[0] && !values.dateRangePayed[1]) ||
            (!values.dateRangePayed[0] && !!values.dateRangePayed[1])
        ) {
            formRef.current.setErrors({
                dateRangePayed: i18n.get("", "Debe ingresar un rango de fechas"),
            });
            return;
        }
        formRef.current.setErrors({
            dateRangePayed: null,
        });

        const finalPayedTo = values.dateRangePayed[1]
            ? new Date(new Date(values.dateRangePayed[1])?.setHours(20, 59, 59, 999))
            : null;

        const requestFilters = {
            ...echeqFilters,
            payedFrom: values.dateRangePayed[0],
            payedTo: finalPayedTo,
            receiver: values.receiver?.toUpperCase() ?? null,
            amountFrom: values.amountFrom?.amount ?? null,
            amountTo: values.amountTo?.amount ?? null,
            typePayment: "PP",
        };
        setFilters(requestFilters);

        setOpenSidebar((state) => !state);
    };
    const handleReset = () => {
        formRef.current.setFieldValue("dateRangePayed", [null, null]);
        formRef.current.setFieldValue("receiver", "");
        formRef.current.setFieldValue("amountFrom.amount", "");
        formRef.current.setFieldValue("amountTo.amount", "");
    };

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} ref={formRef}>
            <Form>
                <Row>
                    <Col xs={12} md={6}>
                        <Field
                            idForm={FORM_ID}
                            name="amountFrom"
                            component={AmountField}
                            hideCurrency
                            className="grid-table-data"
                            labelText={i18n.get("", "Monto desde")}
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <Field
                            idForm={FORM_ID}
                            name="amountTo"
                            component={AmountField}
                            hideCurrency
                            className="grid-table-data"
                            labelText={i18n.get("", "Monto hasta")}
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <Field
                            component={DateRangeField}
                            placeholder
                            defaultLabel={i18n.get("", "Fecha de Vencimiento")}
                            idForm={FORM_ID}
                            minDate={getLimitDate(-184)}
                            maxDate={null}
                            name="dateRangePayed"
                            dateFormat="dd/MM/yyyy"
                            selectsRange
                            showMonthYearDropdown
                            showGlobalPlaceholder
                            scrollableMonthYearDropdown
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <Field
                            component={TextField}
                            placeholderText={i18n.get("forms.bankselector.search")}
                            idForm={FORM_ID}
                            name="receiver"
                            type="text"
                            labelTextDefault={i18n.get("", "Recibido de")}
                            /* pattern="[0.0-9.9]*"
                                maxLength={11}
                                minLength={0} */
                        />
                    </Col>
                </Row>
                <Row className="form-actions">
                    <Col xs={12} md={6}>
                        <Button className="btn-outline" label="echecks.clean.filters" onClick={handleReset} />
                    </Col>
                    <Col xs={12} md={6}>
                        <Button type="submit" className="btn-primary" label="echecks.filtering" />
                    </Col>
                </Row>
            </Form>
        </Formik>
    );
};

FilterForm.propTypes = {
    setFilters: func.isRequired,
    setOpenSidebar: func.isRequired,
};

export default FilterForm;
